// Module
var code = "<product-approval\n  article-id=\"vm.article.id\"\n  folder-id=\"vm.article.folderId\"\n></product-approval>\n";
// Exports
module.exports = code;